module.exports = __webpack_public_path__ + "static/media/card-project1.6857ca8c.jpg";